import React, { useState } from "react";

const PROJECTS = [
  {
    id: 1,
    title: "Heritage Spear-Top Front Fence",
    type: "Iron",
    location: "South East VIC",
    img: "https://customer-assets.emergentagent.com/job_fencing-hub-2/artifacts/4qethzih_IMG_20260511_224125.jpg",
    length: "18m",
  },
  {
    id: 2,
    title: "Stepped Timber Side Boundary",
    type: "Timber",
    location: "South East VIC",
    img: "https://customer-assets.emergentagent.com/job_fencing-hub-2/artifacts/30o593ao_IMG_20260511_223641.jpg",
    length: "62m",
  },
  {
    id: 3,
    title: "Picket-Top White Aluminium",
    type: "Aluminium",
    location: "South East VIC",
    img: "https://customer-assets.emergentagent.com/job_fencing-hub-2/artifacts/4aseva2m_IMG_20260511_223146.jpg",
    length: "24m",
  },
  {
    id: 4,
    title: "Privacy Aluminium w/ Picket Top",
    type: "Aluminium",
    location: "Gippsland",
    img: "https://customer-assets.emergentagent.com/job_fencing-hub-2/artifacts/utfzjdsn_IMG_20260511_222901.jpg",
    length: "38m",
  },
  {
    id: 5,
    title: "Capped Timber Paling New Build",
    type: "Timber",
    location: "South East VIC",
    img: "https://customer-assets.emergentagent.com/job_fencing-hub-2/artifacts/z0ubtl0s_IMG_20260511_222829.jpg",
    length: "44m",
  },
  {
    id: 6,
    title: "Commercial Steel Security Gate",
    type: "Iron",
    location: "South East VIC",
    img: "https://customer-assets.emergentagent.com/job_fencing-hub-2/artifacts/cl3zp13v_IMG_20260416_001714.jpg",
    length: "32m",
  },
  {
    id: 7,
    title: "Modern Slat Aluminium Side Gate",
    type: "Aluminium",
    location: "South East VIC",
    img: "https://customer-assets.emergentagent.com/job_fencing-hub-2/artifacts/p9xp6ymf_IMG_20260511_222316.jpg",
    length: "4m",
  },
  {
    id: 8,
    title: "Charcoal Colorbond Front Boundary",
    type: "Colorbond",
    location: "South East VIC",
    img: "https://customer-assets.emergentagent.com/job_fencing-hub-2/artifacts/sjsiaq73_4762451974165133520.jpg",
    length: "26m",
  },
  {
    id: 9,
    title: "Cream Colorbond Backyard",
    type: "Colorbond",
    location: "Gippsland",
    img: "https://customer-assets.emergentagent.com/job_fencing-hub-2/artifacts/vmc1b5kv_IMG_20260511_223417.jpg",
    length: "58m",
  },
  {
    id: 10,
    title: "Site Hoarding & Mesh Boundary",
    type: "Chain Link",
    location: "Commercial · SE VIC",
    img: "https://customer-assets.emergentagent.com/job_fencing-hub-2/artifacts/r8inlx35_IMG_20260511_222329.jpg",
    length: "85m",
  },
  {
    id: 11,
    title: "Acreage Sports Court Enclosure",
    type: "Chain Link",
    location: "Gippsland",
    img: "https://customer-assets.emergentagent.com/job_fencing-hub-2/artifacts/a0pabr2x_IMG_20260511_222536.jpg",
    length: "48m",
  },
];

const FILTERS = ["All", "Timber", "Aluminium", "Iron", "Colorbond", "Chain Link"];

export default function Gallery() {
  const [filter, setFilter] = useState("All");
  const shown = filter === "All" ? PROJECTS : PROJECTS.filter((p) => p.type === filter);

  return (
    <section id="gallery" data-testid="gallery-section" className="bg-[#0D0D0D] py-24 lg:py-32 border-t border-[#222]">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-8 mb-16">
          <div>
            <div className="text-xs tracking-[0.3em] uppercase text-[#FF5A00] font-bold mb-4">
              [ 02 ] Recent Work
            </div>
            <h2 className="font-heading uppercase text-white text-5xl lg:text-7xl leading-[0.9] tracking-tighter">
              Square Posts.<br />
              <span className="text-[#FF5A00]">Straight Lines.</span>
            </h2>
          </div>
          <div className="flex flex-wrap gap-2">
            {FILTERS.map((f) => (
              <button
                key={f}
                data-testid={`gallery-filter-${f.toLowerCase().replace(" ", "-")}`}
                onClick={() => setFilter(f)}
                className={`px-4 py-2 text-xs tracking-[0.2em] uppercase font-bold transition-all ${
                  filter === f
                    ? "bg-[#FF5A00] text-black"
                    : "bg-transparent text-white/70 border border-[#333] hover:border-[#FF5A00]"
                }`}
              >
                {f}
              </button>
            ))}
          </div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-px bg-[#333]">
          {shown.map((p, idx) => (
            <div
              key={p.id}
              data-testid={`gallery-item-${p.id}`}
              className="group bg-[#0D0D0D] hover:bg-[#1A1A1A] transition-colors overflow-hidden"
            >
              <div className="relative aspect-[4/5] overflow-hidden">
                <img
                  src={p.img}
                  alt={p.title}
                  className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#0D0D0D] via-[#0D0D0D]/30 to-transparent" />
                <div className="absolute top-4 left-4 bg-[#FF5A00] text-black px-3 py-1 text-[10px] tracking-[0.3em] uppercase font-bold">
                  {p.type}
                </div>
                <div className="absolute top-4 right-4 font-heading text-white text-2xl">
                  #{String(idx + 1).padStart(2, "0")}
                </div>
                <div className="absolute bottom-0 left-0 right-0 p-6">
                  <h3 className="font-heading text-white text-2xl uppercase tracking-tight">
                    {p.title}
                  </h3>
                  <div className="flex justify-between mt-2 text-xs tracking-[0.2em] uppercase text-[#A3A3A3]">
                    <span>{p.location}</span>
                    <span className="text-[#FF5A00]">{p.length}</span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
